import { parseModelCreditPricing } from '../utils/modelCreditPricing';
import { modelSupportsImage, readModelCapabilities } from '../../shared/modelCapabilities';

export type RawBoBotModelCatalogEntry = {
  id?: string;
  owned_by?: string;
  supported_endpoint_types?: string[];
  api_format?: 'anthropic' | 'openai' | 'openai-responses';
  capabilities?: string[] | string;
  max_context?: number;
  is_primary?: boolean;
  endpoint_type?: number;
  role?: string;
  weight?: number;
  credit_pricing?: unknown;
};

export function mergeBoBotModelCatalogs(
  primary: RawBoBotModelCatalogEntry[],
  auxiliary: RawBoBotModelCatalogEntry[],
) {
  const byId = new Map<string, RawBoBotModelCatalogEntry>();
  for (const model of [...primary, ...auxiliary]) {
    if (model.id && !byId.has(model.id)) byId.set(model.id, model);
  }

  const defaultModelId = primary.find((model) => model.id)?.id ?? '';
  const models = [...byId.values()].map((model) => {
    const id = model.id ?? '';
    const creditPricing = parseModelCreditPricing(model.credit_pricing);
    const endpointTypes = model.supported_endpoint_types ?? [];
    return {
      id,
      name: id,
      ...(creditPricing ? { creditPricing } : {}),
      supportsImage: modelSupportsImage(model),
      isImageGeneration: readModelCapabilities(model).length
        ? readModelCapabilities(model).some(cap => cap === 'text-to-image' || cap === 'image-to-image')
        : endpointTypes.includes('image-generation'),
      ...(Array.isArray(model.supported_endpoint_types) ? { supportedEndpointTypes: model.supported_endpoint_types } : {}),
      ...(typeof model.api_format === 'string' ? { apiFormat: model.api_format } : {}),
      capabilities: readModelCapabilities(model),
      ...(typeof model.max_context === 'number' ? { maxContext: model.max_context } : {}),
      ...(typeof model.is_primary === 'boolean' ? { isPrimary: model.is_primary } : {}),
      ...(typeof model.endpoint_type === 'number' ? { endpointType: model.endpoint_type } : {}),
      ...(typeof model.role === 'string' ? { role: model.role } : {}),
      ...(typeof model.weight === 'number' ? { weight: model.weight } : {}),
    };
  }).sort((a, b) => a.id.localeCompare(b.id));

  return { defaultModelId, models };
}
